import {
  INVOICE_REGENERATION_SUCCESS,
  INVOICE_REGENERATION_FAILED,
  RESET_INVOICE_REGENERATION,
  LOADING_INVOICE_REGENERATION,
  NETWORK_ERROR_INVOICE_REGENERATION,
} from "../types/index";
import { invoiceServices } from "../../config/axios";

const resetInvoiceRegeneration = () => {
  return { type: RESET_INVOICE_REGENERATION };
};

const invoiceRegeneration = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_INVOICE_REGENERATION });
  await invoiceServices
    .post("regenerate", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(invoiceRegenerationsuccess(res.data));
          break;
        default:
          dispatch(invoiceRegenerationFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_INVOICE_REGENERATION,
        payload: err,
      });
    });
};
function invoiceRegenerationsuccess(data) {
  return {
    type: INVOICE_REGENERATION_SUCCESS,
    payload: data,
  };
}
function invoiceRegenerationFailed(data) {
  return {
    type: INVOICE_REGENERATION_FAILED,
    payload: data,
  };
}

export { resetInvoiceRegeneration, invoiceRegeneration };
